<template>
    <div class="highCharts">
      <div :id="id" ></div>
    </div>
</template>

<script>
import HighCharts from 'highcharts';

export default {
  name: 'highCharts',
  props: {
    id: {
      type: String,
    },
    option: {
      type: Object,
    },
  },
  mounted() {
    HighCharts.chart(this.id, this.option);
    HighCharts.setOptions({
      lang: {
        decimalPoint: '.', // 小数点号，例如 12.50
        thousandsSep: ',', // 千分号，例如 12,000
        numericSymbols: null, // 公制前缀，通过设置为 null 不显示 12k，1.2M 这种形式
      }
    });
  },
};
</script>

<style scoped>

</style>
